<div class="row">
	<div class="column">
		<div class="row">
			<postnick />
		</div>
	</div>
</div>